import styled from "styled-components";

export const IconeCustom = styled.img`
  height: 32px;
  width: 32px;
`;
